export default "__VITE_ASSET__DQh$hlB2__"